export const getBaseFont = font =>
  `font-family: ${font ||
    "gotham"}, 'Helvetica Neue', Helvetica, Arial, sans-serif;`;

export const getFontFamily = (style = "book") => (p = {}) =>
  getBaseFont(`${(p.theme && p.theme.fontFamily) || "gotham"}-${style}`);

/**
 * Returns the theme size
 *
 * @param  {object} p - Props containing the theme object
 * @param  {string} size - The theme size to get. Default: 'large'
 *
 * @return {string} The theme size value
 */
export const getSize = (size = "large") => p =>
  p && p.theme && p.theme.sizes && p.theme.sizes[size];

/**
 * Convert a hex colour code to rgb format
 *
 * @param  {string} hex - The hex value to convert to rbg
 *
 * @return {array} The converted rgb array
 */
export const hexToRgb = hex => {
  if (!hex) {
    return "";
  }

  return hex
    .replace(
      /^#?([a-f\d])([a-f\d])([a-f\d])$/i,
      (m, r, g, b) => "#" + r + r + g + g + b + b
    )
    .substring(1)
    .match(/.{2}/g)
    .map(x => parseInt(x, 16));
};

/**
 * Convert a hex colour code to rgba format with the specified opacity
 *
 * @param  {string} hex - The hex value to convert to rbga. Default: '#000000'
 * @param  {number} opacity - The opacity to apply to the color
 *
 * @return {string} The converted rgba(x, x, x, o) value
 */
export const hexToRgba = (hex = "#000000", opacity = 1) => {
  return `rgba(${hexToRgb(hex).join(", ")}, ${opacity})`;
};

export function isTouchDevice() {
  // https://www.chromestatus.com/feature/4764225348042752
  if (
    navigator &&
    typeof navigator.maxTouchPoints === "number" &&
    navigator.maxTouchPoints > 0
  ) {
    return true;
  }

  if ("ontouchstart" in window) {
    return true;
  }

  if (window.DocumentTouch && document instanceof window.DocumentTouch) {
    return true;
  }

  const prefixes = ["", "-webkit-", "-moz-", "-o-", "-ms-"];
  const queries = prefixes.map(prefix => `(${prefix}touch-enabled)`);

  return window.matchMedia(queries.join(",")).matches;
}
